import React from 'react'
import PropTypes from 'prop-types'

function MosaicInput ({ inputTitle, ...props }) {
  return (
    <div className='form-group row'>
      <label className='col-sm-3 col-md-3 col-lg-2 control-label'>
        {inputTitle}
      </label>
      <div className='col-sm-9 col-md-9 col-lg-10'>
        <div className='input-icon right'>
          <input {...props} />
        </div>
      </div>
    </div>
  )
}

MosaicInput.propTypes = {
  inputTitle: PropTypes.string
}

export default MosaicInput



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/components/MosaicInput.js